import React, { useState, useEffect } from "react";

import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { updateDoc } from "firebase/firestore";
import { MdPhotoCamera } from "react-icons/md";

import { doc } from "firebase/firestore";
import { db } from "../firebase/fireabase"; // import your Firestore instance
import Avatar from "./Avatar";
const EditeMyProfiel = ({
  open,
  handelClose,
  handelOpen,
  id,
  setUser,
  user,
}) => {
  const [username, setUsername] = useState(user.name || "");

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [open]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const storage = getStorage();
    const storageRef = ref(storage, "profileImages/" + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        // Handle error
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          const userDocRef = doc(db, "users", id);
          await updateDoc(userDocRef, {
            photoURL: downloadURL,
          });
          setUser((prevUser) => ({ ...prevUser, photoURL: downloadURL }));
        });
      }
    );
  };

  const handleNameUpdate = async () => {
    const userDocRef = doc(db, "users", id);
    await updateDoc(userDocRef, {
      name: username,
    });
    setUser((prevUser) => ({ ...prevUser, name: username }));
  };

  if (!open) return null;
  return (
    <React.Fragment>
      <div
        class="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal={open.toString()}
        style={{ zIndex: "9999" }}
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <div class="relative transform overflow-hidden rounded-lg  text-left shadow-xl transition-all w-full sm:max-w-3xl sm:w-full">
              <div
                class=" px-4 pb-4 pt-5 sm:p-6 sm:pb-4 sm:w-full sm:flex sm:flex-col"
                style={{
                  backgroundColor: "var(--secondary-color)",
                }}
              >
                <div class="sm:flex sm:items-start">
                  <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                    <h3
                      class="text-base font-semibold leading-6 text-right text-gray-100"
                      id="modal-title"
                      style={{ color: "var(--quaternary-color)" }}
                    >
                      تعديل الحساب
                    </h3>
                    <div class="mt-2 flex flex-col gap-5 justify-center items-center w-full">
                      <div className="relative">
                        <div
                          className="absolute -top-2 -right-2"
                          style={{
                            cursor: "pointer",
                            border: "1px solid #fff",
                            borderRadius: "50%",
                            padding: "5px",
                          }}
                        >
                          <input
                            type="file"
                            id="imageUpload"
                            style={{ display: "none" }}
                            onChange={handleImageUpload}
                          />
                          <label
                            htmlFor="imageUpload"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                          >
                            <MdPhotoCamera size="1.5em" />
                          </label>
                        </div>
                        {user.photoURL ? (
                          <img
                            src={user.photoURL}
                            alt="user"
                            width="100px"
                            height="100px"
                            style={{
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <Avatar Name={user.email} />
                        )}
                      </div>

                      <div class="mt-2">
                        <label
                          for="username"
                          class="block text-sm font-medium text-gray-100 text-right mb-2"
                        >
                          اسم المستخدم
                        </label>
                        <div class="mt-1">
                          <input
                            type="text"
                            name="username"
                            value={username}
                            id="username"
                            autocomplete="username"
                            class="shadow-sm "
                            style={{
                              border: "1px solid #fff",
                              color: "#fff",
                              borderRadius: "10px",
                              padding: "10px",
                            }}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class=" px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6"
                style={{
                  backgroundColor: "var( --primary-color)",
                }}
              >
                <button
                  type="button"
                  class="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-wight shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleNameUpdate();
                    handelClose();
                  }}
                >
                  حفظ
                </button>
                <button
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 shadow-sm px-3 py-2 bg-gray-100 text-sm font-semibold text-black hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:ml-3"
                  onClick={() => handelClose()}
                >
                  الغاء
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EditeMyProfiel;
